import React from "react";
// @ts-ignore
import {Entity} from 'aframe-react';
import {HotSpotGlow} from "./HotSpotGlow";
import {THREE} from "aframe";

// THE DIAL: radius of the ring the viewer sees, in metres. Bigger number, bigger hotspots — the VR
// size and the tap target follow from it, so this is the only value that needs touching.
const RING_RADIUS = 0.24;

const RING_OPACITY = 0.55;

// VR mode lays the scene out four times larger, so sizes and positions in it are scaled to match.
const VR_SCALE = 4;

// The ring keeps its stroke weight at both scales, so the inner edge follows the outer one.
const RING_INNER_RATIO = 2 / 3;

// The invisible disc that catches taps is wider than the ring itself
const HIT_RADIUS_RATIO = 1.5;

// The hover glow spreads well past the ring so it reads as a halo around it rather than a second ring.
const GLOW_SIZE_RATIO = 5;

export function FloorHotSpot(props: {id: string, position: THREE.Vector3, onClick: () => void, isVrMode: boolean}) {
    const {id, position, onClick, isVrMode} = props;

    const scale = isVrMode ? VR_SCALE : 1;
    const ringRadius = RING_RADIUS * scale;
    const hitRadius = ringRadius * HIT_RADIUS_RATIO;
    const glowSize = ringRadius * GLOW_SIZE_RATIO;

    // Spots appear to be floating in VR mode if they are not moved farther down.
    const finalPosition = {x: position.x * scale, y: position.y * scale, z: position.z * scale};

    const material = {flatShading: true, color: "white", side: "double", opacity: RING_OPACITY};
    const geometry = {primitive: "ring", radiusOuter: ringRadius, radiusInner: ringRadius * RING_INNER_RATIO};

    return <Entity id={id} key={id}
                   position={finalPosition}
                   proxy-event__showglow={`event: mouseenter; to: #glow-${id}; as: show`}
                   proxy-event__hideglow={`event: mouseleave; to: #glow-${id}; as: hide`}
                   proxy-event__fade={`event: click; to: #sky; as: fade`}
                   events={{click: onClick}}
                   class="raycastable panoramaHotspot"
                   geometry={{primitive: "circle", radius: hitRadius}}
                   material={{opacity: 0, side: "double"}}
                   rotation={"90 0 0"}
    >
        <Entity  position={"0 0 0.02"} id={"inner-" + id}
                 geometry={geometry}
                 material={material}
        />

        {/*The glow is a transparent image which is shown when mouse is hovering over the hotspot.*/}
        <HotSpotGlow id={id} width={glowSize} height={glowSize} position={new THREE.Vector3(0, 0.01, -0.01)} />
    </Entity>
}
